<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/cross.svg")
    p.ordering__date {{ modalData.date_time }}
    h2.ordering__title {{ modalData.title }}
    p.ordering__address {{ modalData.address }}
    .ordering__form
      form
        .form
          .form__elem
            .form-elem(
            :class="{ 'form-elem_error': fieldsErrors.consent }"
            )
              .form-elem__main
                .controls-list
                  .controls-list__item
                    .control
                      .control__input
                        label.checkbox
                          input.checkbox__input(
                          type="checkbox"
                          v-model="fields.consent"
                          @change="resetError('consent')"
                          )
                          .checkbox__icon
                      .control__text Даю свое согласие на&#32;
                        a.link(
                        href="/docs/Согласие_на_обработку_данных_участника.docx"
                        target="_blank"
                        ) обработку персональных данных согласно ФЗ-152
          .form__elem
            .form-elem
              .form-elem__main
                button.button.button_paint-main.button_full(
                @click.prevent="onSend"
                ) Подать заявку на участие
              .form-elem__error(
              v-if="currentErrorMessage.length > 0"
              ) {{ currentErrorMessage }}
</template>
<script>
import { mapActions } from "vuex";

import AttachFile from "../../attach-file/attach-file";
export default {
  name: "ordering",
  components: { AttachFile },
  props: ["modalData"],
  data() {
    return {
      pending: false,
      fields: {
        consent: false,
        anotherDocuments: [],
      },
      fieldsErrors: {
        consent: false,
      },
      errorMessages: {
        consent: "Необходимо согласие",
        profile: "Необходимо заполнить профиль в личном кабинете",
      },
      currentErrorMessage: "",
    };
  },
  methods: {
    ...mapActions(["createOrder"]),
    changeAttachments(data) {
      this.fields.anotherDocuments = data.value;
    },
    resetError(model) {
      this.fieldsErrors[model] = false;
      this.currentErrorMessage = "";
    },
    onSend() {
      this.pending = true;
      let errors = [];

      if (!this.fields.consent) {
        errors.push("consent");
      }

      if (errors.length > 0) {
        this.pending = false;
        errors.map((el) => {
          this.fieldsErrors[el] = true;
        });
        this.currentErrorMessage = this.errorMessages[errors[0]];
        return;
      }
      this.createOrder({
        awards: this.fields.anotherDocuments,
        event: this.modalData.id,
      }).then((res) => {
        this.pending = false;
        if (res.status === 201) {
          this.$emit("changeModalMode", "notification", {
            title: "Успешно!",
            text:
              "Ваша заявка принята на рассмотрение! Следите за статусом Вашей заявки в личном кабинете.",
          });
        } else if (res.status === 400) {
          if (res.data.profile) {
            this.currentErrorMessage = this.errorMessages["profile"];
          }
          if (res.data.event) {
            this.currentErrorMessage = res.data.event[0].message;
          }
        }
      });
    },
  },
};
</script>
